import {Component, Input, OnInit} from '@angular/core';
import {
    AcabimProject, AcabimSite
} from '@cas-hub/acabim-common-client';
import {MaintenanceType} from '../../../../_models/ltms.model';
import {LtmsService} from '../../../../_services/ltms.service';
import {MessageService, PrimeNGConfig} from 'primeng/api';

export interface LTMSProjectItems {
    readonly id: string;
    readonly maintenance_type_name: string;
    readonly site: AcabimSite;
    readonly project: AcabimProject;
    readonly maintenance_type: MaintenanceType;
    opening_balance_year: { name: number };
    opening_balance_amount: number;
    edit?: boolean;
}

@Component({
    selector: 'acabim-admin-building-financial-management',
    templateUrl: './building-financial-management.component.html',
    styleUrls: ['./building-financial-management.component.scss'],
    providers: [MessageService]
})
export class BuildingFinancialManagementComponent implements OnInit {

    public dataSources: LTMSProjectItems[] = [];
    public backupDS: LTMSProjectItems[] = [];
    _selectedProject?: AcabimProject;
    isLoading = false;

    @Input() set selectedProject(value: AcabimProject) {
        if (value) {
            this.isLoading = true;
            this._selectedProject = value;
            this.refreshData();
        }
    }

    years: { name: number }[] = [];
    currentYear: number = (new Date()).getFullYear();

    constructor(private readonly ltmsService: LtmsService, private messageService: MessageService, private primengConfig: PrimeNGConfig) {
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        this.getYears();
    }

    private refreshData(update: boolean = false): void {
        this.ltmsService.getItemsForProject(this._selectedProject ? this._selectedProject.id : '').subscribe(data => {
            data.forEach((d, i) => {
                data[i].opening_balance_year = {name: (d as any).opening_balance_year};
            });
            this.dataSources = [...data.slice()];
            this.backupDS = JSON.parse(JSON.stringify(data.slice()));
            this.isLoading = false;
            if (update) {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'success',
                    summary: 'opening balance updated'
                });
            }
        });
    }

    getYears(): void {
        this.years = [];
        for (let i = -20; i <= 50; i++) {
            this.years.push({name: this.currentYear + i});
        }
    }

    toggleEdit(record: LTMSProjectItems): void {
        this.years = [];
        for (let i = -20; i <= 50; i++) {
            this.years.push({name: this.currentYear + i});
        }
        this.dataSources.filter(x => x.id === record.id)[0].opening_balance_year =
            this.years.filter(x => x.name === record.opening_balance_year.name)[0] ?
                this.years.filter(x => x.name === record.opening_balance_year.name)[0] :
                this.years.filter(x => x.name === this.dataSources[0].opening_balance_year.name)[0];
        this.dataSources.filter(x => x.id === record.id)[0].opening_balance_amount = record.opening_balance_amount;
        this.dataSources.filter(x => x.id === record.id)[0].edit = true;
    }

    closeEdit(record: LTMSProjectItems): void {
        console.log(this.backupDS);

        this.dataSources.filter(x => x.id === record.id)[0].edit = false;
        if (this.backupDS && this.backupDS.length > 0) {
            this.dataSources = JSON.parse(JSON.stringify(this.backupDS.slice()));
        }
    }

    async saveState(record: any): Promise<void> {
        if (record.opening_balance_year && record.opening_balance_amount) {
            this.isLoading = true;
            this.ltmsService.updatingOpeningBalance(this._selectedProject ?
                this._selectedProject.id : '', record.id,
                record.opening_balance_year.name, record.opening_balance_amount).subscribe(data => {
                this.refreshData(true);
            });

        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Please provide year and amount'
            });
        }
    }
}

